export const INITIAL_ROWS = 5;
export const GRID_TEMPLATE = '32px 110px 1fr 220px 220px 36px';